// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../common/util.bs.js";
import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../css/Theme.bs.js";
import * as React from "react";
import Link from "next/link";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.white),
      tl: {
        hd: BsCss.borderRadius(BsCss.rem(2.0)),
        tl: {
          hd: BsCss.marginTop(BsCss.rem(1.5)),
          tl: {
            hd: BsCss.marginLeft("auto"),
            tl: {
              hd: BsCss.marginRight("auto"),
              tl: {
                hd: BsCss.cursor("pointer"),
                tl: {
                  hd: BsCss.paddingTop(BsCss.rem(0.5)),
                  tl: {
                    hd: BsCss.paddingBottom(BsCss.rem(0.7)),
                    tl: {
                      hd: BsCss.paddingLeft(BsCss.rem(1.0)),
                      tl: {
                        hd: BsCss.paddingRight(BsCss.rem(1.0)),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  container: container
};

var make = React.memo(function (props) {
      return JsxRuntime.jsx(Link, {
                  href: "/logout",
                  prefetch: false,
                  children: JsxRuntime.jsx("div", {
                        children: Util.ReactStuff.s("Log out"),
                        className: container
                      })
                });
    });

var Link$1;

export {
  Link$1 as Link,
  Styles ,
  make ,
}
/* container Not a pure module */
